import { useContext, useLayoutEffect } from "react";

import { Anchor, Stack, Title } from "@mantine/core";

import { TextWrapper } from "./components/TextWrapper";
import { SUPPORT_EMAIL } from "./constants/support";
import { BackgroundContext } from "./contexts/background";

export default function NotFound(): JSX.Element {
  const { setBackground } = useContext(BackgroundContext);

  useLayoutEffect(() => {
    setBackground("white");
  }, [setBackground]);

  return (
    <Stack p="md">
      <Title order={1}>Not found</Title>
      <TextWrapper>We're sorry, page not found error.</TextWrapper>
      <TextWrapper>
        Please contact <Anchor href={`mailto:${SUPPORT_EMAIL}`}>support</Anchor> for assistance.
      </TextWrapper>
    </Stack>
  );
}
